import * as React from 'react';
import Chart from "react-apexcharts";

import { useTranslation } from "react-i18next";
import ReactECharts from "echarts-for-react";

export default function CostChart(props) {

    const {consumption, generation, currencySymbol} = props;

    const { t } = useTranslation();


    let series = []

    
    let timestamps = []
    
        

    if (generation?.optimized?.length > 0){
        timestamps = generation.optimized.map((item)=>item.date)
        series.push(
            {
                name: (consumption?.optimized?.length > 0)? t("Generation (optimised)"): t("Optimised"),
                data: generation.optimized.map((item)=>item.cost),
                type: "line",
                symbol: 'none',
            }
        )
    }

    if (generation?.baseline?.length > 0){
        timestamps = generation.baseline.map((item)=>item.date)
        series.push(
            {
                name: (consumption?.baseline?.length > 0)? t("Generation (baseline)"): t("Baseline"),
                data: generation.baseline.map((item)=>item.cost),
                type: "line",
                symbol: 'none',
            }
        )
    }

    if (consumption?.baseline?.length > 0){
        timestamps = consumption.baseline.map((item)=>item.date)
        series.push(
            {
                name: (generation?.baseline?.length > 0)? t("Consumption (baseline)") : t("Baseline"),
                data: consumption.baseline.map((item)=>item.cost),
                type: "line",
                symbol: 'none',
            }
        )
    }

    if (consumption?.optimized?.length > 0){
        timestamps = consumption.optimized.map((item)=>item.date)
        series.push(
            {
                name: (generation?.optimized?.length > 0)?t("Consumption (optimised)") : t("Optimised"),
                data: consumption.optimized.map((item)=>item.cost),
                type: "line",
                symbol: 'none'
            }
        )
    }

    let options = {
        xAxis: {
            data:timestamps
        },
        yAxis: {
            axisLabel: {
                formatter: (value) => currencySymbol + value
            },
        },
        legend: {
            show: true,
            bottom: 0, 
            left: "center",
        },
        grid: {
            bottom: 45,
            top: 10,
        },
        tooltip: {
            trigger: 'axis', 
            valueFormatter:  (value) => {
                const truncatedValue = typeof value == "number" ? value.toLocaleString(navigator.language,{
                    minimumFractionDigits:2,
                    maximumFractionDigits:2
                }) : value
                const truncatedValueWithCurrency = currencySymbol == '£' ?  currencySymbol + truncatedValue : truncatedValue + currencySymbol
                return truncatedValueWithCurrency
            } 
        },
        series,
        textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
        }
    }
    

    

    return (
        <>
            <ReactECharts option={options} style={{ width: '100%', height: '100%' }}/> 
        </>
    )
};